import PropTypes from 'prop-types'
import React from 'react'
import classnames from 'classnames'
import { connect } from 'react-redux'

import Carousel from './Carousel'
import Icon from './Icon'
import Testimonial from './Testimonial'

const TestimonialsCarousel = ({
  slides,
  extraClass,
  greaterThanXl,
  greaterThanXxl
}) => {
  // _very_ brittle
  let centerPadding = '40px'
  if (greaterThanXxl) {
    centerPadding = '320px'
  } else if (greaterThanXl) {
    centerPadding = '300px'
  }
  return (
    <Carousel
      extraClass={classnames(
        'testimonials-carousel grey',
        extraClass,
        slides.length === 1 && 'testimonials-carousel--single-item'
      )}
      slides={slides}
      sliderOptions={{
        autoplay: false,
        autoplaySpeed: 6000,
        slidesToShow: 1,
        centerPadding,
        centerMode: slides.length > 1,
        dots: false,
        arrows: slides.length > 1,
        // need extra divs because react-slick overrides the classname on the element passed in
        prevArrow: (
          <div>
            <Icon
              className='icon testimonials-carousel__arrow'
              icon='carousel-arrow-left'
            />
          </div>
        ),
        nextArrow: (
          <div>
            <Icon
              className='icon testimonials-carousel__arrow'
              icon='carousel-arrow-right'
            />
          </div>
        )
      }}
      slideRenderFn={testimonial => <Testimonial {...testimonial} />}
    />
  )
}

TestimonialsCarousel.propTypes = {
  extraClass: PropTypes.string,
  slides: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      icon: PropTypes.string,
      content: PropTypes.oneOfType([PropTypes.node, PropTypes.string])
    }).isRequired
  ).isRequired,
  greaterThanXl: PropTypes.bool.isRequired,
  greaterThanXxl: PropTypes.bool.isRequired
}

function mapStateToProps ({ browser }) {
  return {
    greaterThanXl: browser.greaterThan.xl,
    greaterThanXxl: browser.greaterThan.xxl
  }
}

export default connect(mapStateToProps)(TestimonialsCarousel)



// WEBPACK FOOTER //
// ./frontend/scripts/react/components/TestimonialsCarousel.js